import { ReactElement } from "react";
import { useDependency } from "../../../../contexts/DependencyContext";
import { ComponentModelService } from "../../../../services/ComponentModelService";
import { IWidget } from "../../../../services/http/widget/models/IWidget";
import NoData from "../../../../components/Shared/NoData";

function SummaryFullScreen(props: IWidget): ReactElement
{
    const service = useDependency(ComponentModelService);
    const { component, properties } = service.componentModel;
    const hasData = !!component && !!properties;

    return <div>
        {!hasData && <NoData message="There is no data to display." />}
        {hasData &&
            <div>
                <div>
                    <span>{component.description}</span>
                </div>
                <div>
                    <div>
                        <span >Type: </span>
                        <span>{component.componentTypeName}</span>
                    </div>
                    <div>
                        <span >Location: </span>
                        <span>{component.location}</span>
                    </div>
                </div>

                <hr />
                <h4>Properties</h4>
                <ul>
                    {properties.map(x => (
                        <li>
                            <div>
                                <span>{x.name}: </span>
                                <span>{x.valueText}</span>
                            </div>
                        </li>
                    ))}

                </ul>
            </div>}
    </div>;
}

export default SummaryFullScreen;

